export default __webpack_public_path__ + "static/media/Ryukbot.2121f639.png";